import { errorAction, successfulAction } from '@shared/actions';
import { CATEGORY_TYPES, STATUS_CODE } from '@shared/constants';

import getSectionsList from '@services/shops/getSectionsList';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopMenuId from '@core/reducers/shop/selectors/getShopMenuId';
import getHasFetchedSectionList from '@shopDetails/selectors/getHasFetchedSectionList';
import getIsFetchingSectionList from '@shopDetails/selectors/getIsFetchingSectionList';
import { getSectionListLoadStatus } from '@shopDetails/selectors';
import getIsShelvesMenuLayout from '@core/reducers/menu/selectors/getIsShelvesMenuLayout';
import { MenuGridCategoryTree } from '@models/ShopDetails';
import { FETCH_SECTIONS_LIST } from '../actionTypes';

const type = FETCH_SECTIONS_LIST;
const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchSectionsList = () => async (dispatch, getState, axios) => {
  const state = getState();
  const hasFetched = getHasFetchedSectionList(state);
  const isFetching = getIsFetchingSectionList(state);
  const isShelvesMenuLayout = getIsShelvesMenuLayout(state);

  if (isShelvesMenuLayout && hasFetched && !isFetching) {
    try {
      dispatch({ type });

      const shopId = getShopId(state);
      const params = {
        shopId,
        menuId: getShopMenuId(state),
      };

      const sectionListLoadStatus = getSectionListLoadStatus(state);
      if (sectionListLoadStatus && sectionListLoadStatus.count > 0) {
        params.offset = sectionListLoadStatus.count;
      }

      const { success, data, error } = await getSectionsList({
        axios,
        ...params,
      });

      if (success) {
        // It's for the new services, if the type is tree or list, we need to map de response in a different way
        if (
          data.type &&
          (data.type === CATEGORY_TYPES.TREE ||
            data.type === CATEGORY_TYPES.LIST)
        ) {
          dispatch(
            successfulAction({
              type,
              payload: {
                count:
                  data.categories.length > 20 ? 20 : data.categories.length,
                totalSections: data.categories.length,
                sections: MenuGridCategoryTree({ sections: data.categories }),
              },
            }),
          );
        }

        return true;
      }
      dispatch(errorAction({ type, error, errorCode }));
      return false;
    } catch (error) {
      dispatch(
        errorAction({
          type,
          error,
          errorCode,
        }),
      );
    }
  }
  return false;
};

export default fetchSectionsList;
